<template>
  <div class="footer-wrapper">
    <div class="footer-container">
      <div class="footer-instagram">
        <img class="instagram-img" src="@/assets/img/footer/insta_icon.png" alt="instagram">
        <a href="https://www.instagram.com/we.love.lucius.annaeus.seneca/"
          target="_blank">we.love.lucius.annaeus.seneca</a>
      </div>
      <div class="copy-right-text">Copyright © Nao Sato, All rights reserved.</div>
    </div>
  </div>
</template>

<style scoped>
.footer-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* コンテンツを下部に寄せる */
  min-height: 10vh; /* ビューポート全体の高さを確保 */
  box-sizing: border-box;
}

.footer-container {
  width: 80%;
  height: 170px;
  margin: 0 auto; /* 中央揃え */
  border-top: 1px solid;
  border-color: #9c9b96;
  display: flex;
  justify-content: space-between; /* Instagramと著作権を左右に配置 */
  align-items: center;
  padding: 0 16px; /* 左右に余白を追加 */
}

.footer-instagram {
  display: flex;
  align-items: center;
  gap: 1em;
}

.instagram-img {
  width: 18px;
  height: 18px;
  object-fit: cover;
  opacity: 0.7;
}

.footer-instagram a {
  text-decoration: none;
  color: #73726f;
  font-size: 10px;
  font-family: sans-serif;
  transition: color 0.2s ease-out;
  border-bottom: 1px solid #73726f;
  padding-bottom: 3px;
}

.footer-instagram a:hover {
  color: #69b1a9;
  border-color: #69b1a9;
}

.copy-right-text {
  color: #85847f;
  font-size: 10px;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 0.12em;
  text-align: center;
}

@media screen and (max-width: 570px) {
  .copy-right-text {
    font-size: 8px;
    letter-spacing: -0.02em;
  }

  .footer-instagram {
    gap: 0.2em;
  }

  .footer-instagram a {
    font-size: 8px;
  }

  .instagram-img {
    width: 12px;
    height: 12px;
  }
}
</style>